import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { AuthenticationService } from '../Authentication/Services/authentication.service'
import { PermissionService } from '../Authentication/Services/permission.service'
import { MenuService } from '../Authentication/Services/menu.service'

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  isCollapsed = false
  menu: any
  opened = true
  userdata: any
  uiMenu: any = [
    {
      title: 'DASHBOARD',
      match_key: 'DASHBOARD',
      icon: '../../assets/logo/menu/students_menu_logo.svg',
      link: '/dashboard',
      color: '#3f51b5',
      order: 2,
      subMenu: [],
    },
    {
      title: 'CLIENTS',
      match_key: 'CLIENTS',
      icon: '../../assets/logo/menu/staff_menu_logo.svg',
      link: '/client',
      color: '#3f51b5',
      order: 3,
      subMenu: [],
    },
    {
      title: 'APPLICATIONS',
      match_key: 'APPLICATIONS',
      icon: '../../assets/logo/menu/dashboard_menu_logo.svg',
      link: '/applications',
      color: '#3f51b5',
      order: 5,
      subMenu: [],
    },
    {
      title: 'ENVIRONMENTS',
      match_key: 'DEPLOYMENTS_LIST',
      icon: '../../assets/logo/menu/dashboard_menu_logo.svg',
      link: '/environments',
      color: '#3f51b5',
      order: 6,
      subMenu: [],
    },
  ]

  RoleJson: any = {
    permissions: {
      create: true,
      view: true,
      list_view: true,
      edit: true,
      delete: true,
    },
    modules: [
      {
        module_name: 'DASHBOARD',
        access_type: 'FULL_ACCESS',
        sub_modules: [],
      },
      {
        module_name: 'CLIENTS',
        access_type: 'FULL_ACCESS',
        sub_modules: [],
      },
      {
        module_name: 'APPLICATIONS',
        access_type: 'FULL_ACCESS',
        sub_modules: [],
      },
    ],
  }

  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private permissionservice: PermissionService,
    private munuservice: MenuService
  ) {
    if (this.authenticationService.user) {
      this.authenticationService.user.subscribe((x) => {
        this.userdata = x
      })
    } else {
      this.router.navigate(['/login'])
    }
  }
  toggle(): void {
    this.opened = !this.opened
  }

  ngOnInit(): void {
    let updatedMenu: any = []
    let roleJson: any = JSON.parse(this.userdata)?.data.modules
    let permission: any = JSON.parse(this.userdata)?.data.permissions
    //   let roleJson: any = this.RoleJson;

    // Object.keys(roleJson).map((a: any) => {
    //     if (typeof roleJson[a] != "undefined" && typeof roleJson[a].IS_ENABLED != "undefined") {
    //         if (roleJson[a].IS_ENABLED === true) {
    //             let x: any = this.uiMenu.find((ui: any) => { return ui.match_key === a; });
    //             if (typeof x != "undefined") {
    //                 x.subMenuflag = false;
    //                 x.SubMenu = []
    //                 x.actions = roleJson[a].ACTIONS;
    //                 if (x.subMenu.length > 0) {
    //                     x.subMenuflag = true;
    //                     roleJson[a].SUBMENU?.map((b: any) => {
    //                         if (b.IS_ENABLED === true) {
    //                             let y: any = x.subMenu.find((ui: any) => { return ui?.match_key === b?.SUBMENU_NAME; });
    //                             if (typeof y != "undefined") {
    //                                 x.SubMenu.push(y)
    //                             }
    //                         }
    //                     })
    //                 }
    //                 updatedMenu.push(x);
    //             }
    //         }
    //     }
    // });

    roleJson.map((a: any) => {
      if (a.access_type === 'FULL_ACCESS' || a.access_type === 'LIMITED') {
        let x: any = this.uiMenu.find((ui: any) => {
          return ui.match_key === a.module_name
        })
        if (typeof x != 'undefined') {
          x.subMenuflag = false
          x.SubMenu = []
          x.actions =
            (a.access_type === 'FULL_ACCESS' || a.access_type === 'LIMITED') &&
            a.sub_modules?.length == 0
              ? permission
              : a.permissions
          if (a.sub_modules?.length > 0) {
            a.sub_modules?.map((b: any, index: number) => {
              if (
                b.access_type === 'FULL_ACCESS' ||
                b.access_type === 'LIMITED'
              ) {
                let y: any = x.subMenu.find((ui: any) => {
                  return ui?.match_key === b?.sub_module_name
                })
                if (typeof y != 'undefined') {
                  x.SubMenu.push(y)
                  x.SubMenu[index] = {
                    ...x.SubMenu[index],
                    actions:
                      b.access_type == 'FULL_ACCESS'
                        ? permission
                        : b.permissions,
                  }
                }
                // else{
                //     x.SubMenu[index] = { ...x.SubMenu[index], match_key: b.sub_module_name, actions: (b.access_type == 'FULL_ACCESS' ? permission : b.permissions) }
                // }
              }
            })

            if (x.match_key == 'DEMO') {
              x.subMenuflag = false
              this.permissionservice.tabactionsdata = x.SubMenu
            } else {
              x.subMenuflag = true
            }
          }
          delete x['subMenu']
          updatedMenu.push(x)
        }
      }
    })

    updatedMenu.forEach((item: any) => {
      if (item.SubMenu && item.SubMenu.length > 0) {
        item.SubMenu.sort((a: any, b: any) => a.order - b.order)
      }
    })
    updatedMenu.sort(
      (a: { order: number }, b: { order: number }) => a.order - b.order
    )
    this.menu = updatedMenu
    // this.munuservice.menudata = this.menu;
  }

  userlogout() {
    sessionStorage.removeItem('user')
    sessionStorage.removeItem('GEOSERVICE_DATA')
    this.router.navigate(['/applications'])
  }
}
